import styled from 'styled-components'

export const Container = styled.div``

export const Parcelas = styled.div`
    /* border-radius: 10px; */
    /* box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px; */
    background: #fff;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

    border-color: transparent;
    border-color: rgb(209, 213, 219);
    border-width: 1px;
    border-radius: 0.5rem /* 8px */;
    margin-bottom: 20px;
    overflow: auto;
`

export const ListaParcelas = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 500px;

    thead {
        padding: 0 10px;
        /* border-bottom: 1px solid #D3D3D3; */
        border-bottom-style: solid;
        border-bottom-color: transparent;
        border-bottom-color: rgb(209, 213, 219);
        border-bottom-width: 1px;

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            /* height: 63px; */
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */
    }

    tbody {
        tr:not(tr:last-child) {
            /* border-bottom: 1px solid #D3D3D3; */
            border-bottom-style: solid;
            border-bottom-color: transparent;
            border-bottom-color: rgb(209, 213, 219);
            border-bottom-width: 1px;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .link {
            display: flex;
            align-items: center;
            gap: 6px;
        }
    }

    td,
    th {
        padding: 10px 0;
        text-align: left;
    }
`

export const Describe = styled.div`
    /* width: 50%; */
    span {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        color: #333;
    }
`
